import React, { SVGProps } from 'react';

const SvgVolunteerActivism = (props: SVGProps<SVGSVGElement>) => {
	return (
		<svg
			xmlns='http://www.w3.org/2000/svg'
			height='1em'
			viewBox='0 0 24 24'
			width='1em'
			fill='currentColor'
			className='svg-icon'
			{...props}>
			<path fill='none' d='M0 0h24v24H0z' />
			<path
				opacity={0.3}
				d='M3 13h2v7H3zM16 10.29c1.96-1.82 4-3.88 4-4.99 0-.74-.56-1.3-1.3-1.3-.44 0-.89.21-1.18.55L16 6.34l-1.52-1.79A1.59 1.59 0 0013.3 4c-.74 0-1.3.56-1.3 1.3 0 1.11 2.04 3.17 4 4.99zM19 18h-5.35c-.54 0-1.07-.09-1.58-.26l-2.38-.79.63-1.9 2.38.79c.31.1.63.15.95.15H15c0-.37-.23-.7-.57-.83L8.61 13H7v5.48l6.97 1.94 5.93-1.85A.999.999 0 0019 18z'
			/>
			<path d='M16 13c3.09-2.81 6-5.44 6-7.7C22 3.45 20.55 2 18.7 2c-1.04 0-2.05.49-2.7 1.25A3.617 3.617 0 0013.3 2C11.45 2 10 3.45 10 5.3c0 2.26 2.91 4.89 6 7.7zm-2.7-9c.44 0 .89.21 1.18.55L16 6.34l1.52-1.79c.29-.34.74-.55 1.18-.55.74 0 1.3.56 1.3 1.3 0 1.12-2.04 3.17-4 4.99-1.96-1.82-4-3.88-4-4.99 0-.74.56-1.3 1.3-1.3zM19 16h-2c0-1.2-.75-2.28-1.87-2.7L8.97 11H1v11h6v-1.44l7 1.94 8-2.5v-1c0-1.66-1.34-3-3-3zM5 20H3v-7h2v7zm8.97.41L7 18.48V13h1.61l5.82 2.17c.34.13.57.46.57.83h-1.35c-.32 0-.64-.05-.95-.15l-2.38-.79-.63 1.9 2.38.79c.51.17 1.04.26 1.58.26H19c.39 0 .74.23.9.56l-5.93 1.84z' />
		</svg>
	);
}

export default SvgVolunteerActivism;
